import { useEffect } from 'react';

export function XmlFormatter() {
  useEffect(() => {
    console.log('XML Formatter loaded');
    
    function decodeHtml(html: string) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }

    function formatXml(xml: string) {
      const decoded = decodeHtml(xml);
      const reg = /(>)(<)(\/*)/g;
      let formatted = decoded.replace(reg, '$1\n$2$3');
      let pad = 0;
      return formatted.split('\n').map(node => {
        let indent = 0;
        if (node.match(/.+<\/\w[^>]*>$/)) indent = 0;
        else if (node.match(/^<\/\w/)) { if (pad !== 0) pad -= 1; }
        else if (node.match(/^<\w[^>]*[^\/]>.*$/)) indent = 1;
        const padding = '  '.repeat(pad);
        pad += indent;
        return padding + node;
      }).join('\n');
    }

    function processXml() {
      document.querySelectorAll('pre.shiki').forEach(el => {
        const html = (el as HTMLElement).innerHTML;
        if (html && html.includes('&lt;?xml') && !(el as HTMLElement).dataset.formatted) {
          console.log('Formatting XML');
          (el as HTMLElement).textContent = formatXml(html);
          (el as HTMLElement).dataset.formatted = 'true';
          (el as HTMLElement).style.whiteSpace = 'pre';
        }
      });
    }

    const interval = setInterval(processXml, 1000);
    processXml();

    return () => clearInterval(interval);
  }, []);

  return null;
}
